// Список стран для выбора перед оплатой (Sofa 02.09). Способ оплаты зависит от
// страны: РФ (RU) → банковская карта; любая другая → криптовалюта.
export type Country = { code: string; name: string; flag: string };

export const COUNTRIES: Country[] = [
  { code: 'RU', name: 'Россия', flag: '🇷🇺' },
  { code: 'KZ', name: 'Казахстан', flag: '🇰🇿' },
  { code: 'BY', name: 'Беларусь', flag: '🇧🇾' },
  { code: 'AM', name: 'Армения', flag: '🇦🇲' },
  { code: 'GE', name: 'Грузия', flag: '🇬🇪' },
  { code: 'AZ', name: 'Азербайджан', flag: '🇦🇿' },
  { code: 'UZ', name: 'Узбекистан', flag: '🇺🇿' },
  { code: 'KG', name: 'Кыргызстан', flag: '🇰🇬' },
  { code: 'MD', name: 'Молдова', flag: '🇲🇩' },
  { code: 'TJ', name: 'Таджикистан', flag: '🇹🇯' },
  { code: 'DE', name: 'Германия', flag: '🇩🇪' },
  { code: 'FR', name: 'Франция', flag: '🇫🇷' },
  { code: 'ES', name: 'Испания', flag: '🇪🇸' },
  { code: 'IT', name: 'Италия', flag: '🇮🇹' },
  { code: 'GB', name: 'Великобритания', flag: '🇬🇧' },
  { code: 'PL', name: 'Польша', flag: '🇵🇱' },
  { code: 'NL', name: 'Нидерланды', flag: '🇳🇱' },
  { code: 'CZ', name: 'Чехия', flag: '🇨🇿' },
  { code: 'PT', name: 'Португалия', flag: '🇵🇹' },
  { code: 'LT', name: 'Литва', flag: '🇱🇹' },
  { code: 'LV', name: 'Латвия', flag: '🇱🇻' },
  { code: 'EE', name: 'Эстония', flag: '🇪🇪' },
  { code: 'RS', name: 'Сербия', flag: '🇷🇸' },
  { code: 'CY', name: 'Кипр', flag: '🇨🇾' },
  { code: 'US', name: 'США', flag: '🇺🇸' },
  { code: 'CA', name: 'Канада', flag: '🇨🇦' },
  { code: 'AE', name: 'ОАЭ', flag: '🇦🇪' },
  { code: 'TR', name: 'Турция', flag: '🇹🇷' },
  { code: 'IL', name: 'Израиль', flag: '🇮🇱' },
  { code: 'IN', name: 'Индия', flag: '🇮🇳' },
];

/** Способ оплаты по стране: РФ → карта, остальные → крипта. */
export function paymentMethodForCountry(code: string | null | undefined): 'card' | 'crypto' {
  return code === 'RU' ? 'card' : 'crypto';
}
